import { ArrowRight } from "@gravity-ui/icons";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useLocalState } from "../../contexts/LocalStateProvider";
import {
  setOpenOnboardingModal,
  setRedirectAfterSelectedPlan,
  setSubscriptionModal,
} from "../../store/reducers/subscriptionSlice";
import CreateFirstTrack from "./CreateFirstTrack";
import IntroMusicAnimation from "./IntroMusicAnimation";
import Subscription from "./Subscription/Subscription";
import { getCookie } from "../../utils/cookieUtils";
import axios from "axios";
import TaskCompletion from "./TaskCompletion";
import { useGameContext } from "../../contexts/GameContext";
import * as Sentry from "@sentry/react"
import { getPartitionedLocalStorage } from "../../utils/tokenExtraction";

const Onboarding = () => {
  const [showIntro, setShowIntro] = useState(true);
  const [showBillingPlans, setShowBillingPlans] = useState(false);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { localState, updateLocalState } = useLocalState();
  const { openOnboardingModal } = useSelector((state) => state.subscription);
  const [triggerTaskModal, setTriggerTaskModal] = useState(false);
  const { fetchGamificationData , gamificationData } = useGameContext();



  const taskmodal = async () => {
    // console.log("[Onboarding] taskmodal function called");
    try {
      const token = getCookie("token") || getPartitionedLocalStorage("token");
      // Ensure gamificationData and tasks array are available and non-empty before checking task completion
      if (gamificationData && gamificationData.tasks && gamificationData.tasks.length > 0 && gamificationData.tasks[0].is_completed === false) {
        console.log("[Onboarding] Gamification 'signup' task (tasks[0]) is not completed, calling API");
        const response = await axios.post(`${process.env.REACT_APP_SERVER_ENDPOINT}/api/complete-task`,
          {
            "taskKey": "signup"
          }, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        })

        if (response.data.status === "completed") {

          console.log("[Onboarding] 'signup' task API response status is completed");
          setTriggerTaskModal(true); // Show completion modal
          await fetchGamificationData(); // Refresh gamification data locally
          // Removed window.location.reload(); to allow the calling function to handle navigation.
          // The TaskCompletion modal will be shown for 3 seconds.
          setTimeout(() => setTriggerTaskModal(false), 3000);
        }
      } else {
        // Log reason for not calling API (e.g., task already completed or data not available)
        if (!gamificationData || !gamificationData.tasks || gamificationData.tasks.length === 0) {
          console.log("[Onboarding] Gamification data or tasks not available for checking.");
        } else if (gamificationData.tasks[0].is_completed === true) {
          console.log("[Onboarding] Gamification 'signup' task (tasks[0]) is already completed.");
        } else {
          console.log("[Onboarding] Condition to call 'signup' task API not met for other reasons.");
        }
      }
    } catch (error) {
      console.error("[Onboarding] Error during signup completion:", error);
      Sentry.captureException(error);
    }
  }


  //   useEffect(() => {
  //     const token = getCookie("token");
  //     if (!localState.profileCreated && !token) {
  //       navigate("/");
  //     }
  //   }, []);

  return (
    <>
      {openOnboardingModal && (
        <div className="fixed inset-0 z-50 flex justify-center bg-[#1D1B1D] bg-opacity-100 overflow-auto p-2">
          <div className="flex flex-col w-full max-w-4xl bg-[#100F10] border border-[#2c2a2c] p-4 px-6 pb-6 rounded-lg gap-6 mx-auto">
            <div className="flex justify-between w-full pb-4 items-center border-b border-b-[#2C2A2C]">
              {/* Top Left: Logo and Text */}
              <div
                className="relative h-9 flex items-center gap-2 rounded-2.5"
                id="sidebar-logo"
                onClick={() => navigate("/")}
              >
                <img
                  className="w-10 h-10 object-cover rounded-full cursor-pointer"
                  src="/logo@2x.png"
                  alt="Logo"
                  id="sidebar-logo-image"
                />
                <img
                  className="w-[5.9rem] h-8 object-cover z-10 hover:opacity-0 transition duration-500 cursor-pointer"
                  src="/text_only_white.svg"
                  alt="White Text"
                  id="sidebar-logo-text-white"
                />
                <img
                  className="absolute left-12 w-[5.9rem] h-8 object-cover cursor-pointer"
                  src="/text_only_gradient.svg"
                  alt="Gradient Text"
                  id="sidebar-logo-text-gradient"
                />
              </div>

              {/* <div className="flex items-center gap-2">
                {showIntro && (
                  <>
                    <div className={`w-3 h-3 rounded-full bg-white`}></div>
                    <div className={`w-3 h-3 rounded-full bg-[#3C393C]`}></div>
                    <div className={`w-3 h-3 rounded-full bg-[#3C393C]`}></div>
                  </>
                )}
                {showBillingPlans && (
                  <>
                    <div className={`w-3 h-3 rounded-full bg-[#3C393C]`}></div>
                    <div className={`w-3 h-3 rounded-full bg-white`}></div>
                    <div className={`w-3 h-3 rounded-full bg-[#3C393C]`}></div>
                  </>
                )}
                {showSuggestions && (
                  <>
                    <div className={`w-3 h-3 rounded-full bg-[#3C393C]`}></div>
                    <div className={`w-3 h-3 rounded-full bg-[#3C393C]`}></div>
                    <div className={`w-3 h-3 rounded-full bg-white`}></div>
                  </>
                )}
              </div> */}

              {/* Right: Continue Button */}
              <div>
                {showIntro ? (
                  <button
                    onClick={() => {
                      console.log("[Onboarding] Continue button clicked");
                      dispatch(setOpenOnboardingModal(false));
                      taskmodal();
                      console.log("[Onboarding] Checking newUserInvited status:", localState.newUserInvited);
                      if (!localState.newUserInvited) {
                        console.log("[Onboarding] User is NOT invited - setting redirect");
                        dispatch(setRedirectAfterSelectedPlan("/create-team"));
                        dispatch(setSubscriptionModal(false));
                      } else {
                        console.log("[Onboarding] User IS invited - navigating to /");
                        navigate("/");
                      }
                    }}
                    className={`flex items-center text-sm font-normal h-9 px-3 rounded-full transition-all duration-500 ${"bg-gradient-to-b from-[#fc10f2] to-[#3078e4] text-white hover:[background:linear-gradient(135deg,#e509e4,#256bb8)]"}`}
                  >
                    Continue
                    <ArrowRight className="ml-2" />
                  </button>
                ) : (
                  <button
                    onClick={() => {
                      if (showBillingPlans) {
                        setShowBillingPlans(false);
                        setShowSuggestions(true);
                      } else if (showSuggestions) {
                        setShowSuggestions(false);
                        navigate("/");
                      }
                    }}
                    className={`flex items-center text-sm font-normal h-9 px-3 rounded-full transition-all duration-500 [background:var(--Color-Opacity-White-5,rgba(255,255,255,0.05))]`}
                  >
                    Skip
                    <ArrowRight className="ml-2" />
                  </button>
                )}
              </div>
            </div>
            {showIntro && <IntroMusicAnimation />}
            {showBillingPlans && <Subscription />}
            {showSuggestions && <CreateFirstTrack />}
          </div>
        </div>
      )}
      { triggerTaskModal && <TaskCompletion trigger={triggerTaskModal} />}

    </>
  );
};

export default Onboarding;
